import React from "react";
import { Paper, Grid, Typography, Box } from "@mui/material";
import { subSectionSx } from "./bottleOrderFormHelpers";

// Read-only "who is this order for" summary shown above Ordered Bottles.
// Editing stays in the Contact & Address section.
const InfoItem = ({ label, value, multiline }) => (
    <Box>
        <Typography sx={{ fontSize: "0.72rem", color: "text.secondary" }}>{label}</Typography>
        <Typography
            sx={{
                fontSize: "0.875rem",
                fontWeight: 500,
                whiteSpace: multiline ? "pre-wrap" : "normal",
                wordBreak: "break-word",
            }}
        >
            {value?.toString().trim() || "-"}
        </Typography>
    </Box>
);

const ClientContactCard = ({ bottleOrderData }) => {
    if (!bottleOrderData) return null;

    const {
        accountNumber, shippingName, shippingContact, shippingPhone, shippingEmail,
        shippingAddress, shippingAddress2, shippingCity, shippingState, shippingZip,
        pwsNumber, routineShipmentNotes,
    } = bottleOrderData;

    const cityLine = [shippingCity?.trim(), [shippingState?.trim(), shippingZip?.trim()].filter(Boolean).join(" ")]
        .filter(Boolean)
        .join(", ");
    const address = [shippingAddress?.trim(), shippingAddress2?.trim(), cityLine].filter(Boolean).join("\n");

    return (
        <Paper elevation={3} sx={{ p: { xs: 2, sm: 2.5 }, mb: 3 }}>
            <Typography sx={subSectionSx}>Client Contact Information</Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                    <InfoItem
                        label="Account"
                        value={`${accountNumber?.trim() ?? ""}${shippingName?.trim() ? ` - ${shippingName.trim()}` : ""}`}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <InfoItem label="Contact" value={shippingContact} />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <InfoItem label="Phone" value={shippingPhone} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <InfoItem label="Email" value={shippingEmail} />
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <InfoItem label="PWS Number" value={pwsNumber} />
                </Grid>
                <Grid item xs={12} sm={6} md={5}>
                    <InfoItem label="Shipping Address" value={address} multiline />
                </Grid>
                <Grid item xs={12} sm={12} md={7}>
                    <InfoItem label="Routine Shipment" value={routineShipmentNotes} multiline />
                </Grid>
            </Grid>
        </Paper>
    );
};

export default ClientContactCard;
